<mat-list *ngIf="queueData.length; else noQueue;"style="padding-top: 0">
  <mat-list-item style="margin-bottom: 8px">
    <mat-slide-toggle class="queueSlider"
                      [checked]="loggedIn"
                      (change)="sendLoginStateToBackend($event.source.checked)"
                      color="primary"
                      [disabled]="!canEdit"></mat-slide-toggle>
    <span class="mat-content cursorDefault" *ngIf="loggedIn">{{'queue.logged_in' | translate}}</span>
    <span class="mat-content cursorDefault" *ngIf="!loggedIn">{{'queue.logged_out' | translate}}</span>
  </mat-list-item>
  <mat-divider></mat-divider>
  <div class="queue" *ngFor="let qd of queueData">
    <mat-expansion-panel fxFlex>
      <mat-expansion-panel-header>
        <mat-slide-toggle class="queueSlider"
                          [checked]="getMyQueueAgent(qd).active"
                          (change)="updateQueueAgentState(getMyQueueAgent(qd), $event.source.checked)"
                          (click)="$event.stopPropagation()"
                          color=primary
                          [disabled]="!canEdit">
        </mat-slide-toggle>
        <span class="mat-content">
          {{qd.name}}
        </span>
        <span class="mat-content" [ngClass]="getQueueStatusColor(qd)">
          <mat-icon class="groupIcon">group</mat-icon>
          {{qd.agentsLoggedIn}}/{{qd.queueAgents.length}}
        </span>
      </mat-expansion-panel-header>
      <mat-list class="queueMembers">
        <div class="queueMember" *ngFor="let agent of qd.queueAgents" [ngClass]="getQueueAgentStatusColor(agent)">
          <mat-icon>person</mat-icon>
          <span>{{agent.firstName}} {{agent.lastName}} - {{getQueueStatus(agent) | translate}}</span>
        </div>
      </mat-list>
    </mat-expansion-panel>
  </div>
</mat-list>
<ng-template #noQueue>
  {{ 'queues.no_queue' | translate}}
</ng-template>
